document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const open = menu.toggleAttribute('data-open');
      button.setAttribute('aria-expanded', String(open));
    });
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    const select = form.querySelector('[name="id"]');
    const button = form.querySelector('[type="submit"]');
    if (!select || !button) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      button.disabled = option.dataset.available !== 'true';
      button.textContent = option.dataset.available === 'true' ? 'Adicionar ao carrinho' : 'Indisponível';
    });
  });
});
